import React from 'react'
import styled from '@emotion/styled'
import { haulrColors } from '../styles/colors'

type SingleItemBoldOrNormalProps = {
  text: string
  width?: string
}

type SingleItemClickableProps = {
  text: string
  width?: string
  id: string
  onClick: (id: string) => void
}

type SingleItemBoldColorProps = {
  text: string
  width: string
  textColor?: string
  color?: string
}

type TwoLineItemOptionalColorProps = {
  color?: string
  text: string
  subText: string
  width?: string
}

type TwoLineItemClickWithColorProps = {
  text: string
  subText: string
  width?: string
  color?: string
  onClick?: () => void
  hasSublink?: boolean
}

type ToolTipProps = {
  children: any
}

type TdProps = {
  width?: string
  isClickable?: boolean
  borderLeft?: string
}

type BoldTextProps = {
  width?: string
  isClickable?: boolean
  color?: string
}

type SubTextProps = {
  hasSublink?: boolean
}

const SyledTd = styled.td<TdProps>`
  width: ${({ width }) => `${width}%`};
  border-left: ${({ borderLeft }) => borderLeft};
  &:hover {
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : '')};
  }
  & span {
    font-size: 16px;
  }
`

const BoldText = styled.span<BoldTextProps>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ color }) => color};
`

const SubText = styled.span<SubTextProps>`
  font-size: 12px;
  color: #9ea0a5;
  ${({ hasSublink }) =>
    hasSublink &&
    `
    color: #289c91;
    text-decoration: underline;
    cursor: pointer;
  `}
`

const StyledToolTipContainer = styled.td`
  text-align: right;
`

export function SingleItemBold({ text, width }: SingleItemBoldOrNormalProps) {
  return (
    <SyledTd width={width}>
      <BoldText>{text}</BoldText>
    </SyledTd>
  )
}

export function SingleItemNormal({ text, width }: SingleItemBoldOrNormalProps) {
  return (
    <SyledTd width={width}>
      <span>{text}</span>
    </SyledTd>
  )
}

export function SingleItemClickable({ text, width, onClick, id }: SingleItemClickableProps) {
  return (
    <SyledTd width={width} isClickable onClick={() => onClick(id)}>
      <span>{text}</span>
    </SyledTd>
  )
}

export function SingleItemBoldColor({
  color,
  textColor = 'black',
  text,
  width
}: SingleItemBoldColorProps) {
  return (
    <SyledTd width={width} borderLeft={`5px solid ${color}`}>
      <BoldText color={textColor}>{text}</BoldText>
    </SyledTd>
  )
}

export function TwoLineItem({
  text,
  subText,
  width,
  onClick,
  hasSublink
}: TwoLineItemClickWithColorProps) {
  return (
    <SyledTd width={width}>
      <BoldText>{text}</BoldText>
      <br />
      <SubText hasSublink={hasSublink} onClick={onClick}>
        {subText}
      </SubText>
    </SyledTd>
  )
}

export function TwoLineItemWithColor({
  color,
  text,
  subText,
  width
}: TwoLineItemOptionalColorProps) {
  return (
    <SyledTd width={width} borderLeft={`5px solid ${color}`}>
      <BoldText>{text}</BoldText>
      <br />
      <SubText>{subText}</SubText>
    </SyledTd>
  )
}

export function TwoLineItemClick({
  text,
  subText,
  onClick,
  width,
  color
}: TwoLineItemClickWithColorProps) {
  return (
    <SyledTd width={width} borderLeft={`5px solid ${color}`} onClick={onClick}>
      <BoldText>{text}</BoldText>
      <br />
      <SubText>{subText}</SubText>
    </SyledTd>
  )
}

export function ToolTipContainer({ children }: ToolTipProps) {
  return <StyledToolTipContainer>{children}</StyledToolTipContainer>
}

export const colors = [
  'color1',
  'color2',
  'color3',
  'color4',
  'color5',
  'color6',
  'color7',
  'color8'
]

export function LeftSideColor(index: number): { color: string; index: number } {
  const colors = Object.values(haulrColors)
  const num = index % 8
  return { color: colors[num], index: num }
}
